import { WebgalCore } from '@/Core/webgalCore';

export const WebGAL = new WebgalCore();

// 调试，不调试给去掉
// @ts-ignore
// window.WebGAL = WebGAL;
